import * as fromCmdbTagsActions from './tags.actions';
import { ICmdbTagsState } from './tags.reducer';

export
{
    ICmdbTagsState as IState,
    fromCmdbTagsActions as CmdbTagsActions
};
